import { CurrencyPayResponse } from '../redux/models/currencyPay';

const getTransactionId = function getTransactionId(
  responseData: CurrencyPayResponse[]
): string | null {
  const firstTransactionThatHasATransactionId = responseData.find(
    response => response.data && response.data.find(i => i && i.txnId)
  );

  if (firstTransactionThatHasATransactionId) {
    return firstTransactionThatHasATransactionId.data[0].txnId;
  }

  return null;
};
export default getTransactionId;
